import { createFeatureSelector, createSelector } from '@ngrx/store';
import { createRegisterAdapter } from 'src/app/common-components/register/models/register-state.adapter';
import { ActiveCallsRegisterListItem } from '../../models/active-calls-register-results.model';
import { multiFieldSort } from '../register-reducer.factory';
import { accountActiveCallsFeatureKey, AccountActiveCallsState } from './account-active-calls.reducer';

const adapter = createRegisterAdapter<ActiveCallsRegisterListItem, any, any>({
   selectId: (item) => item.callDetailId ?? 0,
});

export const selectAccountActiveCallsState =
   createFeatureSelector<AccountActiveCallsState>(accountActiveCallsFeatureKey);

export const selectors = adapter.getSelectors(selectAccountActiveCallsState);

export const selectOrderingOptions = createSelector(
   selectAccountActiveCallsState,
   (state) => state.orderingOptions ?? []
);

export const selectIsAutoRefresh = createSelector(selectAccountActiveCallsState, (state) => state.isAutoRefresh);

export const selectFilters = createSelector(selectAccountActiveCallsState, (state) => state.filters);

export const selectSortedActiveCalls = createSelector(
   selectors.selectAll,
   selectOrderingOptions,
   (calls, orderingOptions) => multiFieldSort(orderingOptions, calls)
);
